import { GiftOrderResultResponse } from '@models/gift';
import { useTranslation } from 'react-i18next';

import { formatPhoneNo, getSentOrderUiStatus } from '../../../utils';

function useOrderInfo(order: GiftOrderResultResponse) {
    const { t } = useTranslation('gift');
    const hasUsedGift = order.recipients.some((recipient) => (
        recipient.gifts.some((gift) => gift.status === 'USED')
    ));
    const displayStatus = hasUsedGift ? 'USED' : order.status;
    const uiStatus = getSentOrderUiStatus(displayStatus);
    const firstRecipient = order.recipients[0];
    const extraCount = Math.max(order.recipients.length - 1, 0);

    const recipientSummary = (() => {
        if (!firstRecipient) return '-';
        const phone = formatPhoneNo(firstRecipient.phoneNo);
        if (extraCount <= 0) return phone;
        return `${phone} ${t('giftBox.others', { count: extraCount })}`;
    })();

    const statusLabels: Record<GiftOrderResultResponse['status'], string> = {
        PENDING: t('giftSent.status.pending'),
        APPROVED: t('giftSent.status.paid'),
        DONE: t('giftSent.status.paid'),
        FULL_CANCELLED: t('giftSent.status.cancelled'),
        PARTIAL_CANCELLED: t('giftSent.status.partialCancelled'),
        USED: t('giftSent.status.used'),
    };

    const giftLabels = {
        beforeUse: t('giftBox.status.beforeUse'),
        used: t('giftBox.status.used'),
        expired: t('giftBox.status.expired'),
        canceled: t('giftBox.status.canceledDone'),
        deleted: t('giftBox.status.deleted'),
    };

    return {
        uiStatus,
        statusLabel: statusLabels[displayStatus],
        recipientSummary,
        giftLabels,
    };
}

export default useOrderInfo;
